import { logan } from '@/src/pages/order/order_confirm/monitor';

const Raptor = Mach.requireModule('Raptor');
const Logan = Mach.requireModule('Logan');

export const NULL_STRING = 'null';
export const UNDEFINED_STRING = 'undefined';

export enum Step {
  gotoOrderStatusPage = 'gotoOrderStatusPage',
  getDataFromResponse = 'getDataFromResponse',
  MachProGetDataFromNative = 'MachProGetDataFromNative',
  NativeGetDataFromMachPro = 'NativeGetDataFromMachPro',
  PaySuccess = 'PaySuccess',
  validateOrderViewIdEmpty = 'validateOrderViewIdEmpty',
}

export class Monitor {
  /**
     * 通参
     */
  defaultTags = {
    osName: Mach.env.osName ?? '',
    osVersion: Mach.env.osVersion ?? '',
    appVersion: Mach.env.version ?? '',
    platform: Mach.env.isAndroid ? 'Android' : 'iOS',
    bundleVersion: Mach.env.bundleVersion ?? '',
    bundleName: Mach.env.bundleName ?? '',
  }

  /**
     * 上报Report监控指标
     * @param params
     * @param tags
     */
  reportMetrics = (params, tags) => {
    const envName = Mach.env.isDebug ? 'Test' : 'Prod';
    const tagsObj = { ...tags, env: envName };
    // 校验tag数据是否为字符串
    const tagParams = this.checkAndConvertToString(tagsObj);
    Raptor?.reportMetrics?.(params, tagParams, 1.0);
  }

  /**
     * 检查Value类型是否为字符串并转换
     * @param obj
     * @returns
     */
  checkAndConvertToString = (obj) => {
    if (Array.isArray(obj) || typeof obj !== 'object') {
      return obj;
    }
    const convertObj = {};
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        if (typeof obj[key] === 'string') {
          convertObj[key] = obj[key];
        } else if (typeof obj[key] === 'number') {
          convertObj[key] = String(obj[key]);
        }
      }
    }
    return convertObj;
  }

  reportToLoganAndReport = (value: number, values = {}) => {
    const tags = { ...this.defaultTags, ...values, status: value };
    this.reportMetrics({ OrderViewIdEmptyRate: value }, tags);
  }

  reportOrderViewIdEmptyOrUndefined = (orderViewId: string, step: string, data = {}) => {
    let reptorValue = 0;
    const tags = {
      step
    };

    if (!orderViewId || orderViewId === NULL_STRING || orderViewId === UNDEFINED_STRING) {
      reptorValue = 1;
      if (orderViewId === NULL_STRING || orderViewId === UNDEFINED_STRING) {
        this.reportToLoganAndReport(reptorValue, {
          ...tags,
          orderViewId: `${orderViewId}`
        });
      } else {
        this.reportToLoganAndReport(reptorValue, {
          ...tags,
        });
      }
    } else {
      this.reportToLoganAndReport(reptorValue, {
        ...tags,
      });
    }

    const logValue = {
      key: 'EmptyValue',
      ...tags,
      ...this.defaultTags,
      reptorValue,
      orderViewId: `${orderViewId}`,
      data
    };
    logan(logValue);
    console.log(logValue);
  }
}
